import { memo } from "react";
import H1 from "../H1";
import areCommonPropsEqual from "../helpers/areCommonPropsEqual";


function Message ({ cue, baseTheme, baseThemeId }) {
  console.log('Message', cue.id)
  return (
    <H1
      cue={cue}
      text={cue.body}
      baseTheme={baseTheme}
      baseThemeId={baseThemeId}
      whitespace="whitespace-pre" // DON'T remove so that the text will wrap on new line
    />
  )
}

export default memo(Message, (prevProps, nextProps) => {
  // Compare only the properties that affect rendering
  return (
    prevProps.cue.body === nextProps.cue.body

		// APPLIES to ALL CUES
		&& areCommonPropsEqual(prevProps, nextProps)
  )
})